// extracted by precise-mini-css-extract-plugin
export default {"AppContainer":"App_AppContainer--67shhM3X","ErrorBoundary":"App_ErrorBoundary--3Lyhm7n3"};